export default selectOptions => {
  return selectOptions.list.map(element => {
    return {
      label: element[selectOptions.label],
      value: element[selectOptions.value],
    };
  });
};
